import { FeedItem } from '../Feed/feed.types'
import { API_ENDPOINTS } from '../utils/endpoints'
import { makeAPIRequest } from '../utils/request'

export const fetchHighlightsBySlug = async (slug: string): Promise<FeedItem[]> => {
  try {
    const response = await makeAPIRequest(`${API_ENDPOINTS.GET_FEED}`, {
      method: 'GET',
      apiVersion: '4',
      queryParams: { eventSlug: slug },
    })
    if (!response?.data) return []
    return (response.data as FeedItem[]) || []
  } catch (err) {
    console.error('fetch Highlights error', err)
    return []
  }
}
